const avatars: any = {
  '0': '/images/avatars/0.webp',
  '1': '/images/avatars/1.webp',
  '2': '/images/avatars/2.webp',
  '3': '/images/avatars/3.webp',
  '4': '/images/avatars/4.webp',
  '5': '/images/avatars/5.webp',
  '6': '/images/avatars/6.webp',
  '7': '/images/avatars/7.webp',
  '8': '/images/avatars/8.webp',
  '9': '/images/avatars/9.webp',
  '10': '/images/avatars/10.webp',
  '11': '/images/avatars/11.webp',
  '12': '/images/avatars/12.webp',
  '13': '/images/avatars/13.webp',
  '14': '/images/avatars/14.webp',
  '15': '/images/avatars/15.webp'
} as any;

export default avatars;
